module.exports = __webpack_public_path__ + "static/media/roobee.a6b5aebd.svg";